"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageCreater = void 0;
var interface_1 = require("../../../interface");
var util_1 = require("../../../util");
var websocket_channel_1 = require("../../../websocket-channel");
var MessageCreater = /** @class */ (function () {
    function MessageCreater() {
    }
    /**
     * 创建 IBigCollabMessage 数据
     * @param message
     */
    MessageCreater.createMessage = function (message, options, dependency) {
        var _a, _b, _c, _d, _e, _f, _g;
        var postData = this.createPostData(message, options, dependency);
        var newMessage = websocket_channel_1.RoomUtil.createNewMessage(message.taskId || util_1.generateMessageTaskId(), postData, (_b = (_a = message.customParam) === null || _a === void 0 ? void 0 : _a.timeout) !== null && _b !== void 0 ? _b : interface_1.DEFAULT_SEND_MESSAGE_TIMEOUT, (_d = (_c = message.customParam) === null || _c === void 0 ? void 0 : _c.maxRetryCount) !== null && _d !== void 0 ? _d : interface_1.DEFAULT_RETRY_COUNTS, message.cmd, message.data, (_e = message.customParam) === null || _e === void 0 ? void 0 : _e.waitAcceptCmd, message.onError, message.onsend, message.onsendAccept);
        var syncCommit = !!((_g = (_f = options.config) === null || _f === void 0 ? void 0 : _f.bigCollabCommitConfig) === null || _g === void 0 ? void 0 : _g.syncCommit) && message.cmd === "USER_CHANGES" /* USER_CHANGES */;
        return __assign({ syncCommit: syncCommit }, newMessage);
    };
    /**
     * 生成请求 body/head 数据
     * @param message
     */
    MessageCreater.createPostData = function (message, options, dependency) {
        var body = interface_1.prepareCommitMessage(message.data, options.userid, options.serverVars.pver);
        var head = this.createSendHead(message, options, dependency);
        return {
            head: head,
            body: body,
        };
    };
    /**
     * 生成请求 head 数据
     * @param message
     * @returns string
     */
    MessageCreater.createSendHead = function (message, options, dependency) {
        var data = message.data;
        var result = util_1.createMessageHead(options, {
            getHeaderGeneralPacket: dependency.getHeaderGeneralPacket(),
            command: message.cmd,
            baseRev: typeof data === 'object' && typeof data.baseRev === 'number'
                ? data.baseRev
                : dependency.getVersion(),
            taskId: message.taskId || util_1.generateMessageTaskId(),
            additionalFieldsToHead: message.additionalFieldsToHead,
        });
        return result;
    };
    return MessageCreater;
}());
exports.MessageCreater = MessageCreater;
